import React, { useState } from "react";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import IntegrationsService from "../../../../../../../../services/IntegrationsService";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../../../../redux/actions/ui";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import AddNewItem from "../../../../../../../components/modals/AddNewItem";
import Checkbox from '@material-ui/core/Checkbox';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { datetimeToString } from "../../../../../../../../utils/datetime";


const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",    
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
  table: {
    minWidth: 650,
    maxHeight: 100,
  }
}));


function RunSyncIntegration(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [selectedTerms, setSelectedTerms] = useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();

  const onChangeTerm = async (event) => {
    const termId = parseInt(event.target.value);
    if (event.target.checked) {
      // Add term to list
      setSelectedTerms([...selectedTerms, termId]);
    } else {
      // Remove term from list
      setSelectedTerms(selectedTerms.filter(term => term !== termId));
    }
  };
  
  const onSubmit = async data => {
    setIsLoadingSubmit(true);
    console.log(selectedTerms)
    try{
      await IntegrationsService.syncGetIntegration(props.integrationId, selectedTerms, data);
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("Starting sync!"));
      // We updated the list
      props.updateIntegrationFromList();
      props.onClose();
    }catch (error) {
      setIsLoadingSubmit(false);
    }
  };
   
  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit || props.isLoadingTerms || selectedTerms.length === 0}           
          onClick={onSubmit}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            (isLoadingSubmit) ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Get Data
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit || props.isLoadingTerms} actions={actions} title="Canvas Download">

      {props.isLoadingTerms && <h3>Loading terms...</h3>}
      {!props.isLoadingTerms && props.terms.length === 0 && <h3>No terms found</h3>}
      {props.terms.length > 0 && (
        <TableContainer component={Paper} style={{maxHeight: "50em"}}>
        <Table className={classes.table} stickyHeader aria-label="simple table" size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ minWidth: 20 }}></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Start date</TableCell>
              <TableCell>End date</TableCell>
              <TableCell>#Courses</TableCell>
              <TableCell>State</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              {props.terms.map((term, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    <Checkbox checked={term.checked} onChange={onChangeTerm} name={term.name} value={term.id} color="primary"/>
                  </TableCell>
                  <TableCell component="th" scope="row"> {term.name} </TableCell>
                  <TableCell component="th" scope="row"> {(term.start_at && datetimeToString(term.start_at, "MM-DD-YYYY") )|| "-"} </TableCell>
                  <TableCell component="th" scope="row"> {(term.end_at && datetimeToString(term.end_at, "MM-DD-YYYY") )|| "-"} </TableCell>
                  <TableCell component="th" scope="row"> {term.course_count} </TableCell>
                  <TableCell component="th" scope="row"> {term.workflow_state} </TableCell>
                </TableRow>                
              ))}

          </TableBody>
        </Table>
        </TableContainer>
      )}
      
      
    </AddNewItem>
  )
}

export default RunSyncIntegration;